<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button class="toolbarButton" (click)="dismiss()" data-cy="editInput-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>


    <ng-container *ngIf="showTitleOnTop === true">
      <ng-container *ngIf="isFullLabel">
        <ion-title color="primary" data-cy="editLinks-form-formTitle">
          {{inputLabel}} <ion-icon *ngIf="showChoice" class="link" size="small" (click)="showInformationWindow()"
            name="information-circle"></ion-icon>
        </ion-title>
      </ng-container>

      <ng-container *ngIf="!isFullLabel">
        <ion-title color="primary" *ngIf="micrositeUsernameInput === false" data-cy="editInput-form-title">
          Edit {{inputLabel}}
        </ion-title>
        <ion-title color="primary" *ngIf="micrositeUsernameInput === true" data-cy="editInput-form-title">
          Create {{inputLabel}}
        </ion-title>
      </ng-container>
    </ng-container>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" #ionButtonSave color="primary" *ngIf="micrositeUsernameInput !== true"
        [disabled]="isDisabled || (requireValue && (minLimit > inputData?.length ||  inputData?.trim() === ''))"
        (click)="done()" data-cy="editInput-toolbar-save">
        Save
      </ion-button>
      <ion-button class="toolbarButton" #ionButtonCreate color="primary" *ngIf="micrositeUsernameInput === true"
        [disabled]="userTyping === true || isDisabled || usernameAvailable !== true || inputData?.trim() === '' || minLimit > inputData?.length"
        ion-button (click)="done()" data-cy="editInput-toolbar-create">
        Create
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="padding">

  <ng-container *ngIf="showFormTitle === true">
    <ng-container *ngIf="isFullLabel">
      <h3 class="text-center color-dark">
        {{inputLabel}}
      </h3>
    </ng-container>

    <ng-container *ngIf="!isFullLabel">
      <h3 *ngIf="micrositeUsernameInput === false" class="text-center color-dark" data-cy="editInput-form-title">
        Edit {{inputLabel}}
      </h3>
      <h3 *ngIf="micrositeUsernameInput === true" class="text-center color-dark" data-cy="editInput-form-title">
        Create {{inputLabel}}
      </h3>
    </ng-container>
  </ng-container>

  <div class="spacer-20"></div>

  <div class="choiceLabel" *ngIf="showChoice">
    <label>Choice name</label>
  </div>

  <div class="inputs-container" lines="none">
    <div *ngIf="displayCountryPicker" class="country-select">
      <ion-select interface="popover" [(ngModel)]="selectedCountry" slot="start"
        [selectedText]="getCountryFlag(selectedCountry)" [value]="selectedCountry"
        [interfaceOptions]="{'cssClass': 'country-picker-selector'}" mode="ios">
        <ion-select-option *ngFor="let country of COUNTRIES" value="{{country.value}}">{{ country.flag }} {{
          country.displayName }}</ion-select-option>
      </ion-select>
    </div>

    <!-- STRING INPUT -->
    <ion-input *ngIf="!numericInput && rows === 1" autocapitalize="sentences" autocorrect="true" autocomplete="on"
      spellcheck="true" (ngModelChange)="inputData = $event" [(ngModel)]="inputData" (ionChange)="limitText()"
      (keydown)="limitText()" (keyup.enter)="validateBeforeDone()"
      (paste)="onPasteHandler($event.clipboardData.getData('text/plain'))" mode="ios" class="input-height"
      [class.input-borders]="displayCountryPicker" [placeholder]="placeholder" [debounce]="debounceValue"
      [maxlength]="limitNum" #ionInput lines="none" type="text" data-cy="editInput-form-input" />

    <!-- NUMERIC INPUT -->
    <ion-input mode="ios" *ngIf="numericInput && rows === 1" #ionInput lines="none" type="tel" [(ngModel)]="inputData"
      (keydown)="limitText()" [maxlength]="limitNum" (ngModelChange)="inputData = $event" (keyup)="limitText()"
      (paste)="onPasteHandler($event.clipboardData.getData('text/plain'))" (keyup.enter)="validateBeforeDone()"
      data-cy="editInput-form-input" myNumberOnly pattern="[0-9]*">
    </ion-input>

    <!-- MULTI ROW STRING INPUT -->
    <ion-textarea autocapitalize="sentences" *ngIf="rows > 1" #ionTextarea lines="none" type="text" [rows]="rows"
      [(ngModel)]="inputData" (keydown)="limitText()" [maxlength]="limitNum" (ngModelChange)="inputData = $event"
      (keyup)="limitText()" (paste)="onPasteHandler($event.clipboardData.getData('text/plain'))"
      data-cy="editInput-form-input">
    </ion-textarea>
  </div>

  <!-- username helper field -->
  <div *ngIf="micrositeUsernameInput === true" class="padding">
    <ion-spinner *ngIf="inputData !== '' && userTyping === true && minLimit <= inputData?.length" name="crescent">
    </ion-spinner>

    <div class="usernameHelperChar padding" *ngIf="inputData !== '' && minLimit > inputData?.length"
      data-cy="editInput-form-warning">

      Username must be {{minLimit}} characters or more.</div>

    <div class="usernameHelper padding"
      *ngIf="userTyping === false && usernameAvailable === true && inputData !== '' && inputData !== originalText"
      data-cy="editInput-form-warning">
      Username available.</div>
    <div class="usernameHelperTaken padding"
      *ngIf="userTyping === false && usernameAvailable === false && inputData !== '' && inputData !== originalText"
      data-cy="editInput-form-warning">
      {{ usernameErrorDisplay }}
    </div>
  </div>


  <div class="helper-text">
    <p>{{helperText}}</p>
  </div>

  <div class="counter-container">

    <span *ngIf="loaded && !numericInput" [ngClass]="isDark ? 'count-dark' : 'count-danger'"
      data-cy="editInput-form-warning">
      <b>{{countdown}} characters left.</b>
    </span>
    <p class="full-width micrositeNote" *ngIf="micrositeUsernameInput === true" data-cy="editInput-form-warning">

      Your username is part of your link URL. It will appear as curbhe.ro/YourUsername<br />
      <b>TIP:</b> many users will pick the same username as they use on Instagram
    </p>
  </div>

  <div class="spacer-20"></div>
  <div class="choiceLabel" *ngIf="showChoice">
    <label>Choice type</label>
  </div>

  <div class="choiceDetails" *ngIf="showChoice">

    <ion-row class="animation-options-row">
      <div class="animation-col">
        <div [ngClass]="choiceDetails.selectionType === 'ChoiceOnly' ? 'selected-bg' : 'unselected-bg'"
          class="animation-container" (click)="setChoiceType('ChoiceOnly')" data-cy="editInput-choiceType-choiceOnly">
          <img
            [src]="choiceDetails.selectionType === 'ChoiceOnly' ? '/assets/imgs/ChoiceActive-choice-only.svg' : '/assets/imgs/ChoiceInactive-choice-only.svg'" />
          <span class="standardLabel">Choice Only</span>
        </div>
      </div>
      <div class="animation-col">
        <div [ngClass]="choiceDetails.selectionType === 'ChoiceWithDetails' ? 'selected-bg' : 'unselected-bg'"
          class="animation-container" (click)="setChoiceType('ChoiceWithDetails')"
          data-cy="editInput-choiceType-choiceWithDetails">
          <img
            [src]="choiceDetails.selectionType === 'ChoiceWithDetails' ? '/assets/imgs/ChoiceActive-with-details.svg' : '/assets/imgs/ChoiceInactive-with-details.svg'" />
          <span class="standardLabel">Choice With Details</span>
        </div>
      </div>
    </ion-row>

  </div>


  <div class="spacer-20"></div>
  <ng-container *ngIf="showDeleteButton">
    <div class="spacer-15"></div>
    <div class="margin-left-20">
      <ion-button (click)="deleteOption();" ion-button
        data-cy="editInput-choiceType-deleteChoiceBtn">Delete</ion-button>
    </div>

  </ng-container>

  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>